import React from 'react';

function DashboardIcon() {
  return (
    <svg width="21px" height="21px" viewBox="0 0 21 21" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <title>Home</title>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g fill="#404040">
          <polygon points="0 5 4.999 5 4.999 0.001 0 0.001" />
          <polygon points="8 5 12.999 5 12.999 0.001 8 0.001" />
          <polygon points="16 5 20.999 5 20.999 0.001 16 0.001" />
          <polygon points="0 13 4.999 13 4.999 8.001 0 8.001" />
          <polygon points="8 13 13 13 13 8 8 8" />
          <polygon points="16 13 20.999 13 20.999 8.001 16 8.001" />
          <polygon points="0 21 4.999 21 4.999 16 0 16" />
          <polygon points="8 21 12.999 21 12.999 16 8 16" />
          <polygon points="16 21 20.999 21 20.999 16 16 16" />
        </g>
      </g>
    </svg>
  );
}

export default DashboardIcon;



// WEBPACK FOOTER //
// ./src/components/icons/DashboardIcon.js